import React from "react";

// Pill-shaped badge primitive shared by StatusBadge and the VehicleCard status.
// Colours are passed in; sizing can be overridden via `style` for the slightly
// larger vehicle badge.
//
// @param {string} bg - background colour
// @param {string} text - text colour
// @param {string} border - border colour
// @param {object} [style] - overrides merged over the defaults
const Pill = ({ bg, text, border, style, children }) => (
  <span
    className="inline-flex items-center justify-center"
    style={{
      fontSize: 15,
      padding: "2px 16px",
      borderRadius: 9999,
      color: text,
      backgroundColor: bg,
      border: `1.5px solid ${border}`,
      ...style,
    }}>
    {children}
  </span>
);

export default Pill;
